module.exports = __webpack_public_path__ + "img/pivx.0f11fbd4.svg";